<template>
    <div class="content">
        <div class="container-fluid">

            <div class="row">
                <div class="col-md-12">
                    <card v-if="data">
                        <h4 slot="header" class="card-title">Календарь публикаций</h4>
                        <FullCalendar ref="fullCalendar" :options="calendarOptions" />
                    </card>
                </div>
            </div>

        </div>

        <div class="clearfix"></div>
        <div class="video-bg" v-if="activeVideo" @click.prevent="closeVideo()"></div>
        <div id="player" v-if="activeVideo">
            <video onloadstart="this.volume=0.1" controls autoplay id="video_player"
                   style="max-width: 100%;">
                <source v-bind:src="activeVideo"/>
            </video>
            <button type="button" class="btn btn-fill btn-close"
                    @click.prevent="closeVideo()"
                    v-bind:class="{ 'active-state': activeVideo }">
                Закрыть
            </button>
        </div>
    </div>
</template>
<script>
const _ = require('lodash')
const axios = require('axios')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import draggable from 'vuedraggable'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
    components: {
        draggable,
        Card,
        FullCalendar,

    },
    created: function () {
        this.get();
    },
    computed: {
        calendar() {
            return this.$refs.fullCalendar.getApi()
        },
    },
    data() {
        return {
            data: [],
            calendarOptions: {
                themeSystem: 'bootstrap',
                plugins: [ dayGridPlugin, interactionPlugin ],
                initialView: 'dayGridMonth',
                aspectRatio: 2,
                locale: 'Ru',
                buttonText: {
                    today: 'Сегодня',
                },
                eventClick: this.handleEventClick,
                dateClick: this.handleDateClick,
                eventContent: this.renderEventContent,
                renderEvent: this.renderEventContent,
                firstDay: 1,
                fixedWeekCount: false,
                events: [],
            },
            role: parseInt(localStorage.getItem('role')) || 0,
            activeVideo: "",
            status: "1",
            waiting: false,
        }
    },
    methods: {
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(
                `${this.$hostname}/admin/templates/calendar`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.waiting = false;
                    self.data = response.data.templates;

                    for (let i = 0; i < self.data.length; i++) {
                        let t = self.data[i];

                        self.calendar.addEvent({
                            id: t.id,
                            title: t.id,
                            start: t.release_date_history,
                            preview_url: t.src_full,
                        })
                    }
                })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error)
                })

        },
        isVideo: function (url) {
            return url.indexOf('.mp4') > -1;
        },
        renderEventContent: function(eventInfo) {
            let arrayOfDomNodes = []

            let videoWrap = document.createElement('div')
            videoWrap.setAttribute('style', 'width: 100%;cursor: pointer;')

            videoWrap.innerHTML = '<div style="display: table; margin-left: 20px"><span style="color: black; font-weight: 700 !important; display:table-cell;\n' +
                ' vertical-align:middle;">ID: '+ eventInfo.event.id +'</span><video muted loop autoplay playsinline\n' +
                '                                                       style="width: 80px; margin-left: 20px; border-radius: 8px;">\n' +
                '                                                    <source src="' + eventInfo.event.extendedProps.preview_url + '"/>\n' +
                '                                                </video></div>';

            arrayOfDomNodes = [videoWrap]

            return { domNodes: arrayOfDomNodes }
        },
        renderEvent: function(eventInfo) {
            console.log(eventInfo);
        },
        handleEventClick: function(arg) {
            if (this.role < 2) {
                this.$router.push({
                    name: 'edit-template',
                    params: {id: arg.event.id}
                });
            } else {
                this.activeVideo = arg.event.extendedProps.preview_url;
            }

        },
        closeVideo: function () {
            this.activeVideo = "";
        },
        handleDateClick: function(arg) {
            return;
            let calendarApi = this.calendar;
            calendarApi.addEvent({
                id: 3,
                title: 'Meeting',
                start: '2024-04-01T14:30:00',
                image_url: '/static/img/premium.png',
            })
        },
    }
}
</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

html, body {
    -webkit-touch-callout: none;
}

html, body {
    margin: 0;
    max-height: 100%;
    overflow: hidden;
    position: fixed
}
a {
    color: black !important;
}
:root {
     --fc-border-color: black;
     --fc-daygrid-event-dot-width: 5px;
    --fc-event-border-color: black !important;
    --fc-today-bg-color: black;
 }

.btn-close {
    display: none;
    width: 283px;
    height: 40px;
    margin: 33px auto;
    background: #000;
    border: none;
    -webkit-animation: .07s ease 0s normal forwards 1 fadein;
    animation: .07s ease 0s normal forwards 1 fadein;
    font-size: 15px;
}

.btn-close:hover {
    background: #000;
    opacity: 0.8 !important;
}

.btn-close.active-state {
    display: block;
}

@keyframes fadein {
    0% {
        opacity: 0;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-webkit-keyframes fadein {
    0% {
        opacity: 0;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

*::-webkit-scrollbar {
    display: none;
}

.iphone-x .before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
    width: 56%;
    height: 30px;
    background-color: #1f1f1f;
    border-radius: 0px 0px 40px 40px;
    z-index: 99;
}

h2 {
    color: #fff;
}


.scrolling-wrapper .card-template {
    display: inline-block;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.video-bg {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #000000;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10;
    opacity: 0.7;
}

#player {
    width: 324px;
    height: 700px;
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -30%);
    background: #fff;
    z-index: 11;
    transition: all .3s ease-out;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Calendar.vue